import { qbHttp } from "./http";

export const listQbQuotes = (params = {}) =>
  qbHttp.request("api/qb/quotes", { query: params });

export const getQbQuote = (id) => qbHttp.request(`api/qb/quotes/${id}`);

export const createQbQuote = (body) =>
  qbHttp.request("api/qb/quotes", { method: "POST", body });

export const updateQbQuote = (id, body) =>
  qbHttp.request(`api/qb/quotes/${id}`, { method: "PUT", body });

export const deleteQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}`, { method: "DELETE" });

export const replaceDaySlots = (id, daySlots) =>
  qbHttp.request(`api/qb/quotes/${id}/day-slots`, {
    method: "PUT",
    body: { daySlots },
  });

export const recalculateQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}/recalculate`, { method: "POST" });

export const addQbLine = (id, body) =>
  qbHttp.request(`api/qb/quotes/${id}/lines`, { method: "POST", body });

export const updateQbLine = (id, lineId, body) =>
  qbHttp.request(`api/qb/quotes/${id}/lines/${lineId}`, { method: "PUT", body });

export const deleteQbLine = (id, lineId) =>
  qbHttp.request(`api/qb/quotes/${id}/lines/${lineId}`, { method: "DELETE" });

export const sendQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}/send`, { method: "POST" });

export const acceptQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}/accept`, { method: "POST" });

export const cancelQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}/cancel`, { method: "POST" });

export const copyQbQuote = (id) =>
  qbHttp.request(`api/qb/quotes/${id}/copy`, { method: "POST" });
